var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var $8c61827343eed941$exports = require("./useId.main.js");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

$parcel$export(module.exports, "useLabels", function () {
  return $6ec78bde395c477d$export$d6875122194c7b44;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $6ec78bde395c477d$export$d6875122194c7b44(props, defaultLabel) {
  var id = props.id,
      label = props['aria-label'],
      labelledBy = props['aria-labelledby']; // If there is both an aria-label and aria-labelledby,
  // combine them by pointing to the element itself.

  id = (0, $8c61827343eed941$exports.useId)(id);

  if (labelledBy && label) {
    var ids = new Set([id].concat(_toConsumableArray(labelledBy.trim().split(/\s+/))));
    labelledBy = _toConsumableArray(ids).join(' ');
  } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' '); // If no labels are provided, use the default


  if (!label && !labelledBy && defaultLabel) label = defaultLabel;
  return {
    id: id,
    'aria-label': label,
    'aria-labelledby': labelledBy
  };
}